import jsonLogic from "json-logic-js";
import regex from "../json-logic-operations/regex.js";
import length from "../json-logic-operations/length.js";
import dateCalc from "../json-logic-operations/date-calc.js";
import dateParse from "../json-logic-operations/date-parse.js";
import any from "../json-logic-operations/any.js";
import some from "../json-logic-operations/some.js";
import regexp from "../json-logic-operations/rule-regex.js";

export default function(){
    this.main.jsonRule = function jsonRule(cb){
        jsonLogic.add_operation("regex", regex);
        jsonLogic.add_operation("regexp", regexp);
        jsonLogic.add_operation("length", length);
        jsonLogic.add_operation("dateCalc", dateCalc);
        jsonLogic.add_operation("dateParse", dateParse);
        jsonLogic.add_operation("any", any);
        jsonLogic.add_operation("some", some);
        if(this.validates()){
            let model = this.model;
            if(!model) model = this.source;
            let resp = jsonLogic.apply(this.rule.rule, model);
            if(!resp){
                let msg = this.messages["jsonRule"] || "Il campo %s non è valido";
                this.raise(msg, this.field);
            }
        }
        cb();
    };
}
